import { type FC, memo, useMemo } from "react";
import { Heading } from "@stubhub/broadway-web";
import { useAppContext } from "src/shared/context/AppContext";
import { resolveFormattingLocale } from "src/shared/utils/appContextHelper";
import { calendarNavigationHeading } from "./styles";

interface Props {
  /** The specific month date to display */
  monthDate: Date;
}

/**
 * Calendar navigation component that displays a single month and year.
 * Shows the formatted month/year for the provided month date.
 * @returns A heading displaying the month and year
 */
export const CalendarNavigation: FC<Props> = memo(({ monthDate }) => {
  const appContext = useAppContext();
  const locale = resolveFormattingLocale(appContext);

  const formattedDate = useMemo(
    () =>
      monthDate.toLocaleDateString(locale, {
        month: "short",
        year: "numeric",
      }),
    [monthDate, locale],
  );

  return (
    <Heading variant="header" size="small" as="h2" className={calendarNavigationHeading}>
      {formattedDate}
    </Heading>
  );
});
CalendarNavigation.displayName = "CalendarNavigation";
